import {format} from 'date-fns';

import {SelectOption} from 'components/ui-kit/Select';
import {InnerFilters, InnerFilterValue, InnerSortings} from 'types';
import {ApiFilters, ApiSortings} from 'types/api';

export function mapFilters(filters: InnerFilters): ApiFilters {
    const START_DATE_PATTERN = "yyyy-MM-dd'T'HH:mm:ss.sss'Z'";
    const END_DATE_PATTERN = "yyyy-MM-dd'T'23:59:59.999'Z'";

    const convertDate = (date: Date, pattern = START_DATE_PATTERN) =>
        format(new Date(date), pattern || 'yyyy-MM-dd');

    const mapValue = (value: InnerFilterValue, key: string) => {
        if (Array.isArray(value)) {
            // @ts-ignore
            if (value.length === 0 || value.every((elem: any) => elem == null)) {
                return value;
            }

            // if value is date range
            if (value.length === 2 && value.some((elem: any) => elem instanceof Date)) {
                const left = value[0] as Date | null;
                const right = value[1] as Date | null;

                return [
                    {
                        left: convertDate(left || new Date(0)),
                        right: convertDate(right || new Date(), END_DATE_PATTERN),
                    },
                ];
            }

            // if value is number range
            if (value.length === 2 && value.some((elem: any) => !isNaN(Number(elem)))) {
                const KEYS_TO_AVOID = ['buyerLocation'];
                if (KEYS_TO_AVOID.includes(key)) {
                    return value;
                }
                return [
                    {
                        left: value[0],
                        right: value[1],
                    },
                ];
            }

            // if value is SelectOption catalog
            if (typeof value[0] === 'object' && 'value' in (value[0] as any)) {
                return (value as Array<SelectOption<any>>).map(
                    (elem: SelectOption<any>) => elem.value,
                );
            }

            return value;
        }

        // if value is Date
        if (value instanceof Date) {
            return [convertDate(value)];
        }

        // if value is SelectOption
        if (typeof value === 'object' && 'value' in value) {
            return [value.value];
        }

        return [value];
    };

    return Object.entries(filters)
        .filter(([, value]) => value != null)
        .map(([key, value]) => ({id: key, value: mapValue(value, key)}));
}

export function mapSortings(sortings: InnerSortings): ApiSortings {
    return Object.entries(sortings)
        .filter(([, value]) => value != null)
        .map(([key, value]) => ({id: key, desc: value}));
}
